import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './AVEquipments.css';

const AVEquipments = () => {
  const equipment = [
    'Audio System',
    'PA System',
    'LCD TV',
    'Projector',
    'LED Wall',
    'Light Effect',
    'Truss',
    'Dance floor',
    'Gen set',
  ];

  return (
    <div className="av-equipments-page">
      <PageBanner
        title="AV Equipments"
        image={productionRouteBanners['av-equipments']}
        imageAlt={productionRouteBannerAlts['av-equipments']}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Audio Visual Equipment</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Professional audio-visual equipment for flawless event production
            </p>
          </div>
          
          <div className="equipment-grid">
            {equipment.map((item, index) => (
              <div key={index} className="equipment-card">
                <h3>{item}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AVEquipments;
